import styles from "./share-social-media-modal.module.scss";
import { useClipboard } from "@/hooks/use-clipboard";
import SocialMediaButton from "@/components/modal/share-social-media-modal/components/social-media-button";
import FilledButton from "@/components/common/filled-button";
import { socialMedias } from "@/data/social-medias";
import { useMobile } from "@/hooks/use-responsive";

interface ShareSocialMediaModalProps {
  url: string;
  sharedMessageTitle: string;
}

const ShareSocialMediaModal = ({
  url,
  sharedMessageTitle,
}: ShareSocialMediaModalProps) => {
  const { copyToClipboard } = useClipboard();
  const { isMobile } = useMobile();

  return (
    <div className={styles.social_media_modal_wrapper}>
      <div className={styles.modal_title}>
        {isMobile ? (
          "Share"
        ) : (
          <>
            Please choose <br /> the platform to share
          </>
        )}
      </div>
      <div className={styles.social_medias_list}>
        {socialMedias.map((social) => (
          <SocialMediaButton
            key={social.title}
            title={social.title}
            icon={social.icon}
            hoverIcon={social.hoverIcon}
            socialMediaUrl={social.urlGenerator(sharedMessageTitle, url)}
          />
        ))}
      </div>
      <div className={styles.copy_wrapper}>
        <div className={styles.url}>{url}</div>
        <div className={styles.copy_button_wrapper}>
          <FilledButton
            backgroundColor={"#FF5722"}
            color={"#F2F2F2"}
            text={"COPY LINK"}
            onClick={() => copyToClipboard(url)}
          />
        </div>
      </div>
    </div>
  );
};

export default ShareSocialMediaModal;
